import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        minWidth: '400px',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
        backgroundColor: theme.palette.common.white,
        borderRadius: '4px',
        padding: '16px',
        border: `1px solid ${theme.palette.grey[200]}`,
    },
    input: {
        marginTop: '16px'
    },
    currency_select: {
        marginTop: '16px',
        width: '100%'
    },
    exchange_rate_ranges_container: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '16px',
        gap: '12px',
        width: '100%'
    },
    exchange_rate_range_row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
        padding: '12px',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '4px',
        backgroundColor: theme.palette.grey[50]
    },
    range_input: {
        flex: 1
    },
    remove_range_button: {
        minWidth: '40px',
        height: '40px',
        justifyContent: 'center',
    },
    add_range_button: {
        marginTop: '8px',
        alignSelf: 'flex-start'
    },
    ranges_header: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: theme.palette.secondary.main,
        marginTop: '16px',
        marginBottom: '8px'
    }
}));

export {useStyles}

